
export const validatePromptJson = (value, isJsonMode = false) => {
  if (typeof value !== 'string' || !value.trim()) {
    return;
  }
  const jsonInstructionPattern = /json/i;
  const hasJsonInstruction = jsonInstructionPattern.test(value);

  const jsonObjectPattern = /(?<!{){(?!{)[^]*?}/;
  const hasJsonObject = jsonObjectPattern.test(value);
  const rejectWithError = (message) => Promise.reject(new Error(message));

  if (isJsonMode) {
    if (!hasJsonInstruction) {
      return rejectWithError('In order to submit, you must instruct the agent to respond in JSON.');
    }
    if (!hasJsonObject) {
      return rejectWithError('In order to submit, you must include a JSON-like object in your prompt.');
    }
  } else {
    if (hasJsonInstruction && !hasJsonObject) {
      return rejectWithError('You need to remove the JSON instruction, or select "JSON Object" in the Response Format dropdown.');
    }
    if (!hasJsonInstruction && hasJsonObject) {
      return rejectWithError('You either need to remove the JSON object, or select "JSON Object" in the Response Format dropdown.');
    }
    if (hasJsonInstruction && hasJsonObject) {
      return rejectWithError('You either need to remove both the JSON instruction and the JSON object, or select "JSON Object" in the Response Format dropdown.');
    }
  }
  return Promise.resolve();
};
